import React, { useState, useEffect } from 'react';
import api from "../../../services/api";
import './cdn-platforms.css';

const CDNPlatforms = () => {
  const [platforms, setPlatforms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [markCodes, setMarkCodes] = useState([]); // массив для маркировок
  const [inputMark, setInputMark] = useState(''); // текущее значение поля ввода

  // Получение списка площадок из БД
  const fetchPlatformsFromDB = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/check/showcdn');
      if (response.success) {
        setPlatforms(response.platforms);
      }
    } catch (err) {
      setError('Ошибка получения площадок: ' + err.message);
    }
    setLoading(false);
  };

  // Обновление списка CDN-площадок с удалённого сервиса и запись в БД
  const updatePlatforms = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/check/updatecdn');
      if (response.success) {
        setPlatforms(response.platforms);
      }
    } catch (err) {
      setError('Ошибка обновления площадок: ' + err.message);
    }
    setLoading(false);
  };

  // Выполнение health check для всех площадок
  const healthCheckAll = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/check/healthcdn');
      if (response.success) {
        setPlatforms(response.platforms);
      }
    } catch (err) {
      setError('Ошибка выполнения health check для всех площадок: ' + err.message);
    }
    setLoading(false);
  };

  // Health check для конкретной площадки по id
  const healthCheckById = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get(`/check/healthcdn/${id}`);
      if (response.success) {
        const updatedPlatform = response.platform;
        setPlatforms((prevPlatforms) =>
          prevPlatforms.map((p) => (p.id === id ? updatedPlatform : p))
        );
      }
    } catch (err) {
      setError('Ошибка выполнения health check для площадки: ' + err.message);
    }
    setLoading(false);
  };

  // Запрос статуса марки для конкретной площадки по id
  const getMarkStatus = async (id) => {
    setLoading(true);
    setError(null);
    try {
      // Передаём маркировочные коды как строку, разделённую запятыми
      const codesParam = markCodes.join(',');
      const response = await api.get(`/check/status/${id}`, { params: { marks: codesParam } });
      if (response.success) {
        const updatedPlatform = {
          ...platforms.find((p) => p.id === id),
          markStatus: response.status
        };
        setPlatforms((prevPlatforms) =>
          prevPlatforms.map((p) => (p.id === id ? updatedPlatform : p))
        );
      }
    } catch (err) {
      setError('Ошибка запроса статуса марки: ' + err.message);
    }
    setLoading(false);
  };

  // Обработчик добавления нового кода при нажатии Enter
  const handleMarkInputKeyDown = (e) => {
    if (e.key === 'Enter' && inputMark.trim() !== '') {
      if (!markCodes.includes(inputMark.trim())) {
        setMarkCodes(prev => [...prev, inputMark.trim()]);
      }
      setInputMark('');
    }
  };

  // Удаление кода из списка
  const removeMarkCode = (code) => {
    setMarkCodes(prev => prev.filter(c => c !== code));
  };

  useEffect(() => {
    fetchPlatformsFromDB();
  }, []);

  return (
    <div className="cdn-container">
      <h1 className="cdn-title">CDN Площадки</h1>

      {loading && <p className="cdn-loading">Загрузка...</p>}
      {error && <p className="cdn-error">{error}</p>}

      <div className="cdn-input-group">
        <label htmlFor="markInput" className="cdn-label">
          Введите код маркировки:
        </label>
        <input
          type="text"
          id="markInput"
          value={inputMark}
          onChange={(e) => setInputMark(e.target.value)}
          onKeyDown={handleMarkInputKeyDown}
          className="cdn-input"
          placeholder="Нажмите Enter для добавления"
        />
      </div>

      {markCodes.length > 0 && (
        <div className="cdn-tags">
          {markCodes.map((code, index) => (
            <div key={index} className="cdn-tag">
              {code}
              <button className="cdn-tag-remove" onClick={() => removeMarkCode(code)}>
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="cdn-button-group">
        <button className="cdn-button" onClick={updatePlatforms}>
          Запросить актуальные
        </button>
        <button className="cdn-button" onClick={fetchPlatformsFromDB}>
          Посмотреть из БД
        </button>
        <button className="cdn-button" onClick={healthCheckAll}>
          Запросить пинг по всем сразу
        </button>
      </div>

      <table className="cdn-table">
        <thead>
          <tr>
            <th className="cdn-table-header">ID</th>
            <th className="cdn-table-header">Хост</th>
            <th className="cdn-table-header">Порт</th>
            <th className="cdn-table-header">Avg Time (ms)</th>
            <th className="cdn-table-header">Last Checked</th>
            <th className="cdn-table-header">Статус марки</th>
            <th className="cdn-table-header">Действия</th>
          </tr>
        </thead>
        <tbody>
          {platforms.map((platform) => (
            <tr key={platform.id} className="cdn-table-row">
              <td>{platform.id}</td>
              <td>{platform.host}</td>
              <td>{platform.port}</td>
              <td>{platform.avgTimeMs}</td>
              <td>{new Date(platform.lastChecked).toLocaleString()}</td>
              <td>
                {platform.markStatus ? JSON.stringify(platform.markStatus) : 'нет данных'}
              </td>
              <td>
                <button className="cdn-button" onClick={() => healthCheckById(platform.id)}>
                  Запросить пинг
                </button>
                <button className="cdn-button" onClick={() => getMarkStatus(platform.id)}>
                  Запросить статус марки
                </button>
              </td>
            </tr>
          ))}
          {platforms.length === 0 && (
            <tr className="cdn-table-row">
              <td colSpan="7">Нет данных о площадках</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CDNPlatforms;
